function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "FYI---Onboarding---No-Email",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Last-step-with-Chrome-popup",
  transform: "translate(-537.000000, -47.000000)",
  fill: "#FFAB00",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Install-Prompt",
  transform: "translate(0.000000, -15.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 1,
  transform: "translate(450.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(24.000000, 36.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "if_star_216411",
  transform: "translate(1.000000, 26.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.105112,3.68159066 C19.105112,3.68159066 16.834654,3.93306543 15.3200574,4.10119428 C15.1835425,4.11771976 15.0628346,4.20896918 15.0175692,4.34763955 C14.9723037,4.48630993 15.0175692,4.6307283 15.1181591,4.72197771 C16.2433291,5.74871328 17.933958,7.28630189 17.933958,7.28630189 C17.932521,7.28630189 17.4698074,9.52299036 17.1622897,11.0153135 C17.1364237,11.1503914 17.1852817,11.2933728 17.3031156,11.3788742 C17.420231,11.4643756 17.5711158,11.4658126 17.6896682,11.3989922 C19.014581,10.6460048 20.9990762,9.51364987 20.9990762,9.51364987 C20.9990762,9.51364987 22.9842899,10.6460048 24.3070472,11.3997107 C24.4277551,11.4658126 24.57864,11.4643756 24.6957554,11.3788742 C24.8135893,11.2933728 24.8624472,11.1503914 24.8358628,11.016032 C24.528345,9.52299036 24.06635,7.28630189 24.06635,7.28630189 C24.06635,7.28630189 25.7569789,5.74871328 26.8821489,4.72413321 C26.9827388,4.6300098 27.0272858,4.48559143 26.9827388,4.34763955 C26.9381918,4.20968768 26.817484,4.11843826 26.6809691,4.10263128 C25.1663725,3.93306543 22.895196,3.68159066 22.895196,3.68159066 C22.895196,3.68159066 21.9539619,1.59937955 21.3267119,0.211238808 C21.267795,0.0869384211 21.1442131,0 20.9990762,0 C20.8539394,0 20.729639,0.0876569205 20.673596,0.211238808 C20.0456276,1.59937955 19.105112,3.68159066 19.105112,3.68159066 Z",
  id: "Shape"
})))))))));

var SvgStarFilled = function SvgStarFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStarFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StarFilled.36b1f894.svg";
export { ForwardRef as ReactComponent };